import type { SxProps, Theme } from '../../themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    avatar: {
      width: theme.spacing(10),
      height: theme.spacing(10),
      marginLeft: theme.spacing(5),
      marginRight: theme.spacing(4),
      [theme.breakpoints.up('lg')]: {
        width: theme.spacing(14),
        height: theme.spacing(14),
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(8),
      },
    },
    textBox: {
      flexGrow: 1,
      justifyContent: 'center',
    },
    actions: {
      display: 'flex',
      flexWrap: 'wrap',
    },
  };
};
